
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#333"}},[_c('path',{attrs:{"d":"M1.977 11.752H.524a.596.596 0 01-.522-.65V.896a.602.602 0 01.522-.65h1.453a.596.596 0 01.522.65v10.208a.602.602 0 01-.522.65M7.606 11.752H6.153a.596.596 0 01-.522-.65V.896a.602.602 0 01.522-.65h1.453a.596.596 0 01.522.65v10.208a.602.602 0 01-.522.65"}})])])
          )
        }
      }
    